import { ProgressIndicator } from '@dnb/eufemia';
import type { JSX } from 'react';

import Container from '../Container';

export default function LoadingPage(): JSX.Element {
  return (
    <Container centered size="small">
      <ProgressIndicator labelDirection="vertical" showDefaultLabel size="medium" top="x-large" type="linear" />
    </Container>
  );
}
